/*
 * OVERSIGTSKALENDER
 * 
 * Container placeres i html: <div class="overviewWrapper"><input type="date" id="startdate" name="startdate" value="@Model.StartDate" /></div>
 * Initieres med: $(".overviewWrapper").Oversigtskalender(<injicer evt. IOversigtskalenderParameters>);
 * 
 * Oversigten opdateres ved at ændre værdien i inputfeltet "startdate".
 * Husk, hvis værdien ændres via js, så afslut med at kalde .change() på feltet.
 */


// jQuery wrapper
($ => {
    $.fn.Oversigtskalender = function (parameters: Bookhus.IOversigtskalenderParameters) {
        return this.each(function () {
            var oversigtskalender = new Bookhus.Oversigtskalender($(this), parameters);
        });
    };
})(jQuery);


module Bookhus {

    export interface IOversigtskalenderParameters {
        currentCulture: string;
        currentUserId: number;
        currentUserIsAdmin: boolean;
        minBookingBorder: number;
        mediumBookingBorder: number;
        isAdmin: boolean;
        associatedHouseIds: number[];
        showLockInfo: boolean;
        spejder: boolean;
        mayHandleBooking: boolean;
        userIsAllowedToSeePeriodSeperations: boolean;
        separateTime: number;
        hasEventModule: boolean;
        showDaysBeforeTodayAsBooked: boolean;
        showDaysAfterTodayAsBooked: number;
    }
    export interface IHouseInfo {
        id: number;
        name: string;
        domain: string;
        companyName: string;
        encryptedData: string;
        dayStatusService: CalendarDaydataService; // Indeholder bookinger for huset i den valgte periode og getStatusForDay(dayToTest: Date)
    }

    export class Oversigtskalender {
        private container: JQuery;
        private bookingPopup: Bookingpopup;
        private startDate: Date;
        private commonOpeningDate: Date;
        private commonClosingDate: Date;
        private reservationRestrictions = true;
        private houses: IHouseInfo[] = [];
        private localizedValues: LocalizedValues;
        private calendarDayLength = 31;
        private parameters: IOversigtskalenderParameters;
        private updateTimeout: any;
        private separateTime: number

        constructor(container: JQuery, parameters: IOversigtskalenderParameters) {
            this.container = container;
            this.parameters = parameters;
            if (this.parameters === undefined) {
                this.parameters = this.getDefaultparameters();
            }
            this.localizedValues = new LocalizedValues(this.parameters.currentCulture);
            this.bookingPopup = new Bookingpopup(this.parameters.currentCulture, true, this.parameters.spejder, this.parameters.hasEventModule);
            this.getStartDate();
            $.getJSON(`/api/overview/GetBookingPeriodInformation?userId=${this.parameters.currentUserId}`, info => {
                this.commonOpeningDate = new Date(info.openingDate).getDateWithoutTime();
                this.commonClosingDate = new Date(info.closingDate).getDateWithoutTime();
                this.reservationRestrictions = info.reservationRestrictions;
                this.drawHeader();
                this.loadHouseList();
                this.setInputChangeEvent();
            });
            
        }

        private getDefaultparameters(): IOversigtskalenderParameters {
            var parameters: IOversigtskalenderParameters = {
                currentCulture: "da",
                currentUserId: 0,
                currentUserIsAdmin: false,
                minBookingBorder: 5,
                mediumBookingBorder: 10,
                isAdmin: false,
                associatedHouseIds: [],
                showLockInfo: false,
                spejder: false,
                mayHandleBooking: false,
                userIsAllowedToSeePeriodSeperations: false,
                separateTime: 12,
                hasEventModule: false,
                showDaysBeforeTodayAsBooked: true,
                showDaysAfterTodayAsBooked: 0
        };
            return parameters;
        }

        private getStartDate() {
            var date = $.datepicker.parseDate(this.localizedValues.datePattern, this.findInputField().val());
            if (date < new Date(2000, 1, 1)) {
                date = new Date(Date.now());
            }
            this.startDate = date;
        }

        private setStartDate(date: Date) {
            //this.findInputField().val(date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear()).change();
            this.findInputField().val($.datepicker.formatDate(this.localizedValues.datePattern, date)).change();
            // Udløser change-event på input-felt
        }

        private setInputChangeEvent() {
            this.findInputField().on("change", () => {
                this.updateCalender();
            });
        }

        private updateCalender() {
            var self = this;

            self.getStartDate();
            self.updateDateDropdowns();
            self.updateHeader();

            clearTimeout(self.updateTimeout);
            self.updateTimeout = setTimeout(function () {
                self.houses.forEach(house => {
                    self.updateHouse(house);
                });
            }, 200);
        }

        private findInputField(): JQuery {
            var inputField = this.container.find("#startdate");
            if (inputField === undefined || inputField === null) {
                throw new Error("Datofeltet findes ikke");
            }
            return inputField;
        }

        private drawHeader(): void {
            var month = this.createMonthDropdown();
            var year = this.createYearDropdown();
            this.container.append(`
                <div class="overview-head-placeholder"><div class="overview-head-wrapper"><div class="overview-head-container"><div class="overview overview-head">
                    <div class="month-selector">
                        <div class="month-selector-buttons">
                            <span class="fa fa-chevron-left monthBack"></span>
                            <span class="show-month-selector-fields">${$("#localizedStrings").attr("data-vælgmåned")}</span>
                            <span class="fa fa-chevron-right monthForward"></span>
                        </div>
                        <div class="month-selector-fields" style="display: none;">
                            ${month} ${year} <span class="hide-month-selector-fields">Vis</span>
                        </div>
                    </div>
                    <div class="tableWrapper"></div>
                </div></div></div></div>
            `);
            this.container.find(".monthBack").on("click", () => {
                this.moveMonth(-1);
            });
            this.container.find(".monthForward").on("click", () => {
                this.moveMonth(1);
            });
            this.container.find(".show-month-selector-fields").on("click",() => {
                this.container.find(".month-selector-buttons").slideUp();
                this.container.find(".month-selector-fields").slideDown();
            });
            this.container.find(".hide-month-selector-fields").on("click",() => {
                this.container.find(".month-selector-buttons").slideDown();
                this.container.find(".month-selector-fields").slideUp();
                var selectedMonth = this.container.find(".monthDropdown").val();
                var selectedYear = this.container.find(".yearDropdown").val();
                this.moveToMonthInYear(selectedMonth, selectedYear);
            });
            //var self = this;
            //this.container.find(".monthDropdown").on("change", function() {
            //    self.moveToMonth($(this).val());
            //});
            //this.container.find(".yearDropdown").on("change", function () {
            //    self.moveToYear($(this).val());
            //});
            // Fix header i toppen af vinduet, når den scroller ovenud. Se kommentar til de mange div'er i stylesheet
            var head = this.container.find(".overview-head-wrapper");
            var headOrigin = head.offset().top;
            var headWidth = head.width();
            var headIsFixed = false;
            $(window).on("scroll", this.debounce(() => {
                if ($(window).scrollTop() > headOrigin) {
                    if (screen.width >= 1200) {
                        if (!headIsFixed) {
                            head.addClass("overview-head-fixed");
                            head.css('width', headWidth);
                            headIsFixed = true;
                        }
                    }
                    
                } else {
                    if (screen.width >= 1200) {
                        if (headIsFixed) {
                            head.removeClass("overview-head-fixed");
                            head.css('width', '');
                            headIsFixed = false;
                        }
                    }
                    
                }
            }, 10, false));
            this.updateHeader();
        }

        private createMonthDropdown(): string {
            var monthDrop = "";
            this.localizedValues.monthNames.forEach((month, index) => {
                var selected = index === this.startDate.getMonth() ? ' selected="selected"' : "";
                monthDrop += `<option value="${index}"${selected}>${month}</option>`;
            });
            return `<select class="monthDropdown">${monthDrop}</select>`;
        }

        private createYearDropdown(): string {
            var yearDrop = "";
            var yearsBack = -5;
            var yearsForward = 5;
            for (var i = yearsBack; i <= yearsForward; i++) {
                var currentYear = this.startDate.getFullYear() + i;
                var selected = currentYear === this.startDate.getFullYear() ? ' selected="selected"' : "";
                yearDrop += `<option value="${currentYear}"${selected}>${currentYear}</option>`;
            }
            return `<select class="yearDropdown">${yearDrop}</select>`;
        }

        private updateDateDropdowns(): void {
            this.container.find(".monthDropdown").val(this.startDate.getMonth().toString());
            this.container.find(".yearDropdown").val(this.startDate.getFullYear().toString());
        }

        private updateHeader(): void {
            if (!this.startDateIsInOpenPeriod()) {
                return;
            }
            var months = "";
            var monthCount = 1;
            var weeks = "";
            var weekCount = 1;
            var days = "";
            for (var i = 0; i < this.calendarDayLength; i++) {
                var currentDate = this.startDate.addDays(i);
                var nextDate = (new Date(currentDate.getTime())).addDays(1);
                // Sammensæt måneder
                var currentMonth = currentDate.getMonth();
                var nextMonth = nextDate.getMonth();
                if (currentMonth !== nextMonth || i + 1 === this.calendarDayLength) {
                    var monthText = monthCount >= 4 ? this.localizedValues.monthNames[currentMonth] + " " + currentDate.getFullYear() : "";
                    months += `<td colspan="${monthCount}"><b>${monthText}</b></td>`;
                    monthCount = 0;
                }
                monthCount++;
                // Sammensæt uger
                var currentWeek = currentDate.getWeek();
                var nextWeek = nextDate.getWeek();
                if (currentWeek !== nextWeek || i + 1 === this.calendarDayLength) {
                    var weekText = weekCount >= 2 ? this.localizedValues.uge + " " + currentWeek : "";
                    weeks += `<td colspan="${weekCount}">${weekText}</td>`;
                    weekCount = 0;
                }
                weekCount++;
                // Sammensæt dage
                //var currentDayOfWeek = currentDate.getDay();
                var currentDayOfMonth = currentDate.getDate();
                //var dayClass = currentDayOfWeek === 0 || currentDayOfWeek === 6 ? ' class="weekend"' : "";
                var dayClass = "";
                var title = "";
                if (currentDate.isHolyday()) {
                    dayClass = " class='weekend' ";
                    title = ` title="${currentDate.getHolydayName()} "`;
                }

                days += `<td${dayClass}${title}><div>${currentDayOfMonth}</div></td>`;
            }
            var header = `<table>
                <tr>${months}</tr>
                <tr>${weeks}</tr>
                <tr>${days}</tr>
            </table>`;
            $(".overview-head .tableWrapper").empty().append(header);
        }


        private loadHouseList(): void {
            $.getJSON(`/api/overview/houselist?locale=${this.parameters.currentCulture}&userId=${this.parameters.currentUserId}`, houses => {
                if (houses.length > 0) {

                    var externalHouses = [];

                    houses.forEach(house => {
                        if (house.domain) {
                            externalHouses.push(house);
                            return;
                        }

                        var newHouse: IHouseInfo = {
                            id: house.id,
                            name: house.name,
                            domain: '',
                            companyName: '',
                            encryptedData: '',
                            dayStatusService: new CalendarDaydataService(this.parameters.minBookingBorder, this.parameters.mediumBookingBorder, this.parameters.currentUserId, this.parameters.currentUserIsAdmin || this.parameters.userIsAllowedToSeePeriodSeperations, this.parameters.separateTime)
                        }
                        this.houses.push(newHouse);
                        this.drawHouseContainer(newHouse);
                    });

                    //Vi behøver kun vise ekstern header, hvis man også har egne emner
                    if (externalHouses.length > 0 && houses.length - externalHouses.length > 0) {
                        this.drawExternalHeader();
                    }

                    externalHouses.forEach(house => {
                        var newHouse: IHouseInfo = {
                            id: house.id,
                            name: house.name,
                            domain: house.domain ? 'https://' + house.domain : '',
                            companyName: house.companyName || '',
                            encryptedData: house.encryptedData || '',
                            dayStatusService: new CalendarDaydataService(this.parameters.minBookingBorder, this.parameters.mediumBookingBorder, this.parameters.currentUserId, this.parameters.currentUserIsAdmin || this.parameters.userIsAllowedToSeePeriodSeperations, this.parameters.separateTime)
                        }
                        this.houses.push(newHouse);
                        this.drawHouseContainer(newHouse);
                    });
                }
            });
        }

        private drawExternalHeader(): void {
            this.container.append(`
                <div class="overview overview-house" style="height: 29px;">
                    <div class="text-center" style="line-height: 29px; font-weight: 700;">${this.localizedValues.externalHouses}</div>
                </div>
            `);
        }

        private drawHouseContainer(house: IHouseInfo): void {
            //var house = this.houses.find(h => h.id === id);
            this.container.append(`
                <div class="overview overview-house" id="house-${house.id}">
                    <div class="info-toggle"><span class="info-icon info-icon-loading">i</span>${house.name}</div>                    
                    <div class="tableWrapper"></div>
                    <div class="info-content" data-visble="false" data-loaded="false" style="display: none;"></div>
                </div>
            `);
            $(`#house-${house.id} .info-toggle`).on("click", () => {
                this.toggleHouseInfo(house);
            });
            this.updateHouse(house);
        }

        private updateHouse(house: IHouseInfo): void {
            if (!this.startDateIsInOpenPeriod()) {
                return;
            }
            $(`#house-${house.id} .tableWrapper`).empty().closest(".overview-house").find(".info-icon").removeClass("info-icon-ready").addClass("info-icon-loading");
            var self = this;
            var xhr = house.dayStatusService.loadDataAjax(house.id, this.startDate, this.startDate.addDays(31), house.domain);
            xhr.always(function (jqxhr, textStatus, error) {
                self.drawHouseCalender(house);
            });
        }

        private drawHouseCalender(house: IHouseInfo): void {
            var self = this;
            var calendar = "";
            var today = new Date().getDateWithoutTime().addDays(self.parameters.showDaysAfterTodayAsBooked);

            for (var i = 0; i < this.calendarDayLength; i++) {
                var currentDate = this.startDate.addDays(i);

                var title = self.isAdmin(house) ? "Klik for mere info" : "Klik for at vælge datoen";
                var currentDayName = this.localizedValues.dayNamesMin[currentDate.getDay()];
                var currentDayStatus = house.dayStatusService.getStatusForDay(currentDate, !!house.domain);

                var dayHasPrice = house.dayStatusService.dayHasPrice(currentDate);
                if (!dayHasPrice) {
                    currentDayStatus = "noprice";
                }

                var dayActive = "";
                var disableSysMaxForDay = house.dayStatusService.sysMaxDateGælderIkkeForLodtrækninger && currentDayStatus.indexOf('drawperiod') > -1;
                if (this.reservationRestrictions && (!dayHasPrice || (currentDate > house.dayStatusService.houseOpenUntill && !disableSysMaxForDay) || currentDate > this.commonClosingDate || currentDayStatus.indexOf('restrictedPeriod') > -1)) {
                    dayActive = "day-not-active";
                    title = "";
                }
                currentDayStatus = currentDayStatus.replace('restrictedPeriod', '');

                if (currentDayStatus.indexOf("locked") > -1 && !this.parameters.showLockInfo && !self.isAdmin(house) ) {
                    currentDayStatus = currentDayStatus.replace("locked", "reservation");
                }
                else if (currentDayStatus === "locked" && this.parameters.showLockInfo && self.isAdmin(house)) {
                    title = "Periode er låst. Klik for mere info";
                }
                else if (currentDayStatus === "locked" && this.parameters.showLockInfo)
                {
                    title = "Periode er låst.";
                }

                if (self.parameters.showDaysBeforeTodayAsBooked && currentDate.getDateWithoutTime().getTime() < today.getTime() && !self.isAdmin(house)) {
                    currentDayStatus = "reservation";
                    title = "";
                }

                calendar += `<td data-date="${currentDate.toString("dd-MM-yyyy") }" data-title="${title}" class="${dayActive}"><div class="bookingDay"><div class="bookingColor ${currentDayStatus}"></div><div class="bookingText">${currentDayName}</div></div></td>`;
            }
            calendar = `<table><tr>${calendar}</tr></table>`;
            $(`#house-${house.id} .tableWrapper`).empty().append(calendar).closest(".overview-house").find(".info-icon").removeClass("info-icon-loading").addClass("info-icon-ready");
            
            $(`#house-${house.id} td:not(".day-not-active")`).on("click", function () {
                var dateString = $(this).attr("data-date").split("-");
                var bookingDate = new Date(+dateString[2], +dateString[1] - 1, +dateString[0]);
                
                var bookhusPortalPopUp = window["bookhusPortalPopUp"];
                if (bookhusPortalPopUp && house.domain.length > 0) {
                    bookhusPortalPopUp.show(house.companyName, house.encryptedData, "/book/" + house.id);
                    return;
                }
                else if (house.dayStatusService.getStatusForDay(bookingDate) === "locked" && self.parameters.showLockInfo) {
                    // Vis bookingpopup hvis Admin
                    if (self.isAdmin(house)) //Admin check bliver lavet her, for at undgå link til booking side på låst periode..
                    {
                        self.bookingPopup.showLockInfo(house.id, bookingDate, self.parameters.mayHandleBooking);
                    }
                }
                else if (self.isAdmin(house)) {
                    // Vis bookingpopup hvis Admin
                    self.bookingPopup.showPopup(house.id, bookingDate, self.parameters.mayHandleBooking);
                }
                else {
                    // Ellers gå til bookingkalenderen
                    var url = `/book/${house.id}?date=${$(this).attr("data-date")}`;
                    if (house.domain.length > 0) {
                        url = "https://" + house.domain + url;
                    }
                    window.location.href = url;
                }
            });

            const TOOLTIP_DELAY: number = 500;
            const TOOLTIP_TIMEOUT: string = 'tooltipTimeout';

            $(`#house-${house.id} td:not(".day-not-active")`).on('mouseenter', (e) => {
                var $target = $(e.currentTarget);
                clearTimeoutData($target);
                $target.data(TOOLTIP_TIMEOUT, setTimeout(() => {
                    $target.off('mouseenter');

                    var title = $target.data('title');

                    var bookhusPortalPopUp = window["bookhusPortalPopUp"];
                    if (!this.isAdmin(house) || bookhusPortalPopUp && house.domain.length > 0) {
                        displayTooltip($target, title);
                    }
                    else {
                        var dateString = $target.attr("data-date").split("-");
                        var bookingDate = new Date(+dateString[2], +dateString[1] - 1, +dateString[0]);
                        house.dayStatusService.getTitleForDay(bookingDate).then((status) => {
                            if ($target.data(TOOLTIP_TIMEOUT)) {
                                displayTooltip($target, title + '\n ' + status);
                            }
                        });
                    }
                }, TOOLTIP_DELAY));
            });

            $(`#house-${house.id} td:not(".day-not-active")`).on('mouseleave', (e) => {
                var $target = $(e.currentTarget);
                clearTimeoutData($target);
            });

            function clearTimeoutData($target: JQuery) {
                clearTimeout($target.data(TOOLTIP_TIMEOUT));
                $target.data(TOOLTIP_TIMEOUT, null);
            }

            function displayTooltip($target: JQuery, title: string) {
                $target.tooltip({
                    title: title,
                    trigger: 'hover',
                    delay: { show: TOOLTIP_DELAY, hide: 0 }
                } as any);

                $target.on('click', function () {
                    $(this).tooltip('hide');
                });
                $target.tooltip('show');
            }
        }

        private isAdmin(house) {
            var self = this;
            return self.parameters.isAdmin || !self.parameters.isAdmin && self.parameters.associatedHouseIds.indexOf(house.id) > -1;
        }

        private toggleHouseInfo(house: IHouseInfo) {
            var wrapper = $(`#house-${house.id} .info-content`);
            if (wrapper.attr("data-visible") !== "true") {
                if (wrapper.attr("data-loaded") !== "true") {
                    this.loadHouseInfo(house);
                } else {
                    wrapper.slideDown().attr("data-visible", "true");
                }
            } else {
                wrapper.slideUp().attr("data-visible", "false");
            }
        }

        private loadHouseInfo(house: IHouseInfo): void {
            var url = "";
            if (house.domain.length > 0) {
                url = house.domain + url;
            }

            var wrapper = $(`#house-${house.id} .info-content`);
            wrapper.closest(".overview-house").find(".info-icon").removeClass("info-icon-ready").addClass("info-icon-loading");
            $.getJSON(`/api/overview/housedescription?locale=${this.parameters.currentCulture}&houseId=${house.id}`, description => {
                var content = `<div class="d-flex position-relative">
                    <div class="flex-fill pr-4" style="flex-basis: 100% !important;">
                        <img src="${url}/Houseimage/${description.imageId}/300/300" class= "img-fluid" />
                        <div class="gallery-copyright">${description.copyright}</div>
                    </div>
                    <div class= "informationwrapper pl-4">
                        ${description.description}
                        <p>
                            <a href="${url}/book/${house.id}" class="btn btn-success" style="min-width: 100px;" data-bookhusportal="${(house.domain.length > 0 ? "show" : "")}" data-propertyowner="${house.companyName}" data-encrypteddata="${house.encryptedData}" data-redirectto="/book/${house.id}">${$("#localizedStrings").attr("data-book")}</a> 
                            <a href="${url}/House/${house.id}" class="btn btn-primary ml-2" style="min-width: 100px;" data-bookhusportal="${(house.domain.length > 0 ? "show" : "")}" data-propertyowner="${house.companyName}" data-encrypteddata="${house.encryptedData}" data-redirectto="/house/${house.id}">${$("#localizedStrings").attr("data-mereinfo")}</a>
                        </p>
                    </div>
                </div>`;
                wrapper.append(content).slideDown().attr("data-loaded", "true").attr("data-visible", "true").closest(".overview-house").find(".info-icon").removeClass("info-icon-loading").addClass("info-icon-ready");
            });
        }


        public moveMonth(distance: number) {

            var oldDate = this.startDate;
            var targetDate = new Date(this.startDate.getTime());
            targetDate.setDate(1);
            targetDate.setMonth(targetDate.getMonth() + distance);

            // Vi understøtter kun 5 år frem i tiden, og lader derfor ikke brugeren futte længere frem end det..
            if (targetDate.getFullYear() > new Date(Date.now()).getFullYear() + 5) {
                return;
            }

            this.setStartDate(targetDate);
            this.getStartDate();
            if (!this.startDateIsInOpenPeriod()) {
                this.setStartDate(oldDate);
            }
        }

        public moveToMonth(target: number) {
            if (target < 0 || target > 11) {
                throw new Error("Ugyldig måned. Angiv 0 til 11.");
            }
            var targetDate = new Date(this.startDate.getTime());
            targetDate.setDate(1);
            targetDate.setMonth(target);
            this.setStartDate(targetDate);
        }

        public moveToYear(target: number) {
            var targetDate = new Date(this.startDate.getTime());
            targetDate.setDate(1);
            targetDate.setFullYear(target);
            this.setStartDate(targetDate);
        }

        public moveToMonthInYear(targetMonth: number, targetYear: number) {
            var oldDate = this.startDate;
            if (targetMonth < 0 || targetMonth > 11) {
                throw new Error("Ugyldig måned. Angiv 0 til 11.");
            }
            if (targetYear < 2000 || targetYear > 2100) {
                throw new Error("Ugyldigt år angivet.");
            }
            var targetDate = new Date();
            targetDate.setDate(1);
            targetDate.setMonth(targetMonth);
            targetDate.setFullYear(targetYear);

            this.setStartDate(targetDate);
            this.getStartDate();
            if (!this.startDateIsInOpenPeriod()) {
                this.setStartDate(oldDate);
            }


        }

        private startDateIsInOpenPeriod(): boolean {
            var firstDisplayableDate = new Date(this.commonOpeningDate.getTime());
            firstDisplayableDate.setDate(1); // Den 1. i den måned, som har datoen for nedre grænse for booking

            return this.startDate >= firstDisplayableDate && this.startDate <= this.commonClosingDate;
        }

        private debounce(func, wait, immediate) {
            var timeout;
            return function () {
                var context = this, args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        }

    }


} 